module.exports = __webpack_public_path__ + "static/header-image-01-b0051f330e20260f09a2eada4ef811ab.png";